"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const zustandStore_1 = require("../../../../zustandStore");
const simpleHeader_1 = __importDefault(require("../../../organisms/header/simpleHeader"));
const coding_1 = __importDefault(require("../../../templates/companySettings/coding"));
const CompanySettingsCodingPage = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        ...(initialData && 'user' in initialData && { initialData: initialData.user }),
    });
    const { data: teams } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.teamsQuery)({ state: 'active' }),
        ...(initialData && 'teams' in initialData && { initialData: initialData.teams }),
    });
    const { setUser, setCompanyName, setCompanyId, setHeaderName, setTeams } = (0, zustandStore_1.useZustand)();
    (0, react_1.useEffect)(() => {
        if (userData) {
            setUser(userData);
            setCompanyName(userData.companyName);
            setCompanyId(userData.companyAccountId);
            setHeaderName(userData.companyName);
            setTeams(teams);
        }
    }, [setCompanyId, setCompanyName, setHeaderName, setTeams, setUser, teams, userData]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleHeader_1.default, {}), (0, jsx_runtime_1.jsx)(coding_1.default, {})] }));
};
exports.default = CompanySettingsCodingPage;
